import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useSearchParams } from 'react-router-dom';
import { checkAHAVI } from 'utils/utils';
import { dateFormat } from 'utils/shared/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { Hotel, HotelDetails } from 'ts/hotel/interfaces/HotelDetails';
import RoomDetailsAi from './RoomDetailsAi';
interface DetailsSummaryProps {
  hotelDetails: HotelDetails;
  oneHotel?: Hotel;
}

const DetailsSummary: FC<DetailsSummaryProps> = ({ hotelDetails, oneHotel }) => {
  const [urlParams] = useSearchParams();
  const { t } = useTranslation();
  const location = useLocation();

  const detailsStrParams = urlParams.get('details');
  const detailsObjParams = new URLSearchParams(detailsStrParams || '');

  const isValidPage =
    /^(\/hotel\d*\/details|\/hotels(?:\d+)?\/results)$/.test(location.pathname) &&
    location.search.includes('details');

  return (
    <div className="w100p details-summary-abs">
      <div className="details-summary default-shadow">
        <div
          className="title-underline text-lg mb-20 title-header-grey"
          style={{ paddingTop: 40, paddingBottom: 26.5 }}
        >
          {t('hotel.facilities')}
        </div>
        {isValidPage && (
          <div className="details-summary-content">
            <div className="flex-row">
              <div className="mb-5 w100p">
                {t('search.max_occupancy')}:{' '}
                <span className="text-bold">{detailsObjParams.get('maxOccupancy')}</span>
              </div>

              <div className="mb-5 w100p">
                {t('search.check_in')}:{' '}
                <span className="text-bold">
                  {dateFormat(urlParams.get('checkIn') || '', 'EEE - dd MMMM, yyyy')}
                </span>
              </div>
              <div className="mb-5 w100p">
                {t('search.check_out')}:{' '}
                <span className="text-bold">
                  {dateFormat(urlParams.get('checkOut') || '', 'EEE - dd MMMM, yyyy')}
                </span>
              </div>
              <div className="mb-20 w100p">
                {t('hotel.nights_up')}:{' '}
                <span className="text-bold">{detailsObjParams.get('nights')}</span>
              </div>
            </div>

            {!!hotelDetails.hotelFacilities?.length && (
              <Fragment>
                <div className="title-underline text-md">{t('hotel.facilities')}</div>
                <div className="mb-10 facility-wr">
                  {hotelDetails.hotelFacilities.map((facility, index) => {
                    return (
                      <div
                        key={index}
                        className={'facility' + (checkAHAVI(facility) ? ' rtl' : ' ltr')}
                      >
                        <FontAwesomeIcon icon={faCircle} />
                        {facility}
                      </div>
                    );
                  })}
                </div>
              </Fragment>
            )}
          </div>
        )}
      </div>

      <RoomDetailsAi hotel={oneHotel} />
    </div>
  );
};
export default withErrorBoundary(DetailsSummary, 'DetailsSummary');
